
// You can write more code here

/* START OF COMPILED CODE */

import EditorTrapMarker from "../../../EditorTrapMarker";
/* START-USER-IMPORTS */
/* END-USER-IMPORTS */

export default class TrapMarkerTorch extends EditorTrapMarker {

  constructor(scene: Phaser.Scene, x?: number, y?: number, texture?: string, frame?: number | string) {
    super(scene, x ?? 44, y ?? 64, texture || 'game-all', frame ?? "skull-torch.png");

    /* START-USER-CTR-CODE */
    // Write your code here.
    /* END-USER-CTR-CODE */
  }

  /* START-USER-CODE */

  // Write your code here.

  /* END-USER-CODE */
}

/* END OF COMPILED CODE */

// You can write more code here
